import { connect } from 'react-redux';

import { hideLoading, showLoading } from 'store/actions/Global';
import NewsOverview from './NewsOverview';

const mapDispatchToProps = (dispatch) => ({
    hideLoading: () => hideLoading()(dispatch),
    showLoading: () => showLoading()(dispatch),
});

export default connect(null, mapDispatchToProps)(NewsOverview);
